export const CIPO_THEME_MODE = 'CIPO_THEME_MODE';
export const CIPO_THEME = 'CIPO_THEME';
export const AUTH_TOKEN = 'msal.idtoken';
export const TENANT = 'ls.CurrentTenant';
export const CONTRACT = 'ls.currentContract';
export const MODULE = 'ls.currentModule';
export const MODULE_PREFERENCES = 'cipo.modulePreferences';
export const REDIRECT_PATH = 'redirectPath';
export const LAST_CONTRACT_CONTEXT_STORAGE_KEY = 'ls.lastContractContext';
export const MENU_COLLAPSED_KEY: string = 'ls.menu.collapsed';
export const APP_VERSION: string = 'ls.app.version';
export const APP_BUILD_NUMBER: string = 'ls.app.buildNumber';
export const A11Y_CONTRAST: string = 'ls.a11y.contrast';
export const A11Y_REDUCE_MOTION: string = 'ls.a11y.reduceMotion';
export const A11Y_FONT_SCALE: string = 'ls.a11y.fontScale';
export const A11Y_TEXT_SPACING: string = 'ls.a11y.textSpacing';
export const A11Y_LINE_HEIGHT: string = 'ls.a11y.lineHeight';
export const A11Y_SATURATION: string = 'ls.a11y.saturation';
export const A11Y_UNDERLINE_LINKS: string = 'ls.a11y.underlineLinks';
export const A11Y_DYSLEXIA_FONT: string = 'ls.a11y.dyslexiaFont';
export const A11Y_COLOR_FILTER: string = 'ls.a11y.colorFilter';
export const A11Y_LARGE_CURSOR: string = 'ls.a11y.largeCursor';
export const A11Y_READING_AID: string = 'ls.a11y.readingAid';
